const useProductViewItemTracking = ({ product }) => {
  try {
    const ecommerce = {
      currency: product.currencyCode,
      items: [
        {
          item_name: product?.name,
          item_id: product?.id,
          price: product?.price,
          item_brand: 'Keune',
          item_category: product?.category,
          item_category2: product?.category2,
          ...(product?.category3 && { item_category3: product?.category3 }),
          ...(product?.itemListName && { item_list_name: product?.itemListName }),
          ...(product?.itemIndex && { index: product?.itemIndex }),
          quantity: 1,
          is_item_in_stock: product?.outOfStock,
          image_url: product?.imageUrl,
          compare_at_price: product?.compareAtPrice,
        },
      ],
    };

    if (typeof window !== 'undefined' && window.dataLayer) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.

      window.dataLayer.push({
        event: 'view_item',
        ecommerce,
      });
    } else {
      setTimeout(() => {
        if (typeof window !== 'undefined' && window.dataLayer) {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.

          window.dataLayer.push({
            event: 'view_item',
            ecommerce,
          });
        }
      }, [process.env.GTM_DELAY]);
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('There was an error sending data to Google Tag Manager: ', error);
  }
};

export default useProductViewItemTracking;
